document.addEventListener('DOMContentLoaded', function() {
    let popupShown = false;

    const overlay = document.getElementById('exit-popup-overlay');
    const popup = document.getElementById('exit-popup');
    const text = document.getElementById('exit-popup-text');
    const closeX = document.getElementById('exit-popup-close');
    const goToCartBtn = document.getElementById('exit-popup-cart');

    function showExitPopup(itemCount) {
        text.textContent = `Don't forget your cart! You have ${itemCount} item${itemCount > 1 ? 's' : ''}.`;
        overlay.style.display = 'block';
        popup.style.display = 'block';
        setTimeout(() => {
            popup.style.bottom = '50%';
            popup.style.opacity = '1';
        }, 50);
    }

    function closePopup() {
        popup.style.bottom = '-100%';
        popup.style.opacity = '0';
        overlay.style.display = 'none';
        setTimeout(() => popup.style.display = 'none', 500);
    }

    closeX.addEventListener('click', closePopup);
    overlay.addEventListener('click', closePopup);

    document.addEventListener('mouseout', function(e) {
        if (!popupShown && e.clientY < 10) {
            popupShown = true;

            fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    if(cart.item_count > 0) {
                        showExitPopup(cart.item_count);
                    }
                })
                .catch(err => console.error('Cart fetch error:', err));
        }
    });
});
